import type { ReactElement } from 'react';
import { ProductCardPlaceholder } from '@/entities/product';

/**
 * 폭마다 한 줄만 채운다 — 1열(기본) 1칸, sm 2열 2칸, lg 4열 4칸.
 * 그리드 열 수·간격은 ProductCardGrid 와 같은 값이다.
 */
const SKELETON_TILES = [
  { key: '1', className: 'block' },
  { key: '2', className: 'hidden sm:block' },
  { key: '3', className: 'hidden lg:block' },
  { key: '4', className: 'hidden lg:block' },
] as const;

/** 목록을 불러오는 동안 자리를 지키는 빈 칸 그리드 — 카드 사진 칸과 같은 글자 없는 회색 면이다. */
export const ProductCardGridSkeleton = (): ReactElement => (
  <ul aria-hidden className="grid gap-x-4 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
    {SKELETON_TILES.map((tile) => (
      <li key={tile.key} className={tile.className}>
        <ProductCardPlaceholder />
      </li>
    ))}
  </ul>
);
